import { Flex } from "@payping/web-components";
import PersonalPageLink from "./PersonalPage";
import Carousel from "./Carousel";
import ReferralCode from "./ReferralCode";
import BlogPosts from "./BlogPosts";

const Sidebar = () => (
  <aside>
    <Flex vertical gap="16px" justify="center" align="center">
      {/* < صفحه شخصی > */}
      <PersonalPageLink />

      {/* < اسلاید بنر > */}
      <Carousel />

      {/* < کسب درامد > */}
      <ReferralCode />

      {/* < مقالات پی پینگ > */}
      <BlogPosts />
    </Flex>
  </aside>
);

export default Sidebar;
